// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"cad1e7c9","404":"8d9650c1","498":"be0f9fd0"}[chunkId] + ".chunk.js";
};